import React, { createContext, useContext, useMemo, useState } from 'react';
import { PageContext } from '@leuven2030/framework/Page/Page';

export const NewsContext = createContext({
  allResults: [],
  filteredResults: [],
  setFilteredResults: (value) => null
});
const NewsProvider = (props) => {
  const {
    prismic: {
      allNews_articles: { edges: allResults }
    }
  } = useContext(PageContext);

  const [filteredResults, setFilteredResults] = useState([]);

  useMemo(() => {
    if (filteredResults.length) {
      return;
    }
    setFilteredResults(allResults);
  }, [allResults]);

  return (
    <NewsContext.Provider
      value={{ filteredResults, setFilteredResults, allResults }}
      {...props}
    />
  );
};

export default NewsProvider;
